<template>
  <Cover @click="$emit('click')" class="cover-weixin-share">
    <div class="text">
      <div>
        <span>点击浏览器下方 “</span>
        <span class="icon"><i class="fa fa-bars" aria-hidden="true"></i></span>
        <span>” 分享给微信好友</span>
      </div>
      <div>
        <span>safari浏览器请点击 “</span>
        <span class="icon"><i class="fa fa-external-link" aria-hidden="true"></i></span>
        <span>” 按钮</span>
      </div>
    </div>
    <div class="img"></div>
  </Cover>
</template>

<script>
import Cover from './Cover.vue'
export default {
  components: { Cover }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.cover-weixin-share {
  & .text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    height: 20%;
    text-align: center;
    font-size: var(--textSize1);
    line-height: 2rem;
    color: var(--colorWhite);
  }
  & .icon {
    color: var(--color1);
  }
  & .img {
    position: absolute;
    bottom: 20%;
    height: 20%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-image: url('http://az.cdn.nutsbp.com/007/image/nuts_dartcome/phone/pr/cut_page/pr_phone_gesture_down.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cover/BrowserShareCover.vue